import { createContext } from 'react';

export type UpdateRentChargeFormModalContextProps = {
  closeModal: () => void
  openModal: (rentChargeId: string) => void
  rentChargeId: string | null
  isOpen: boolean
}

export const UpdateRentChargeFormModalContext = createContext<UpdateRentChargeFormModalContextProps | null>(null)

